import { render } from "./DotsNavigation.vue?vue&type=template&id=5d132140&scoped=true&ts=true"
import script from "./DotsNavigation.vue?vue&type=script&lang=ts"
export * from "./DotsNavigation.vue?vue&type=script&lang=ts"

import "./DotsNavigation.vue?vue&type=style&index=0&id=5d132140&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d132140"]])

export default __exports__